import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { SELECT_LABELS, withSelectPlaceholder } from '../../services/selectOptions';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';

registerLocale('es', es);

const PERIODO_OPTIONS = withSelectPlaceholder(
  [
    { value: 'A', label: 'Anual' },
    { value: '1', label: 'Primer Cuatrimestre' },
    { value: '2', label: 'Segundo Cuatrimestre' },
  ],
  SELECT_LABELS.periodoCursada
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddPeriodoCursada extends Component {
  static displayName = AddPeriodoCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      anio: { codigo: '', descripcion: '' },
      startDate: new Date(),
      endDate: new Date(),
      startInscriptionDate: new Date(),
      endInscriptionDate: new Date(),
      periodo: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWPeriodoCursada');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handlePeriodoChange = (option) => {
    this.clearFeedback();
    this.setState({ periodo: option ? option.value : '' });
  };

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupAnios: false,
      anio: {
        codigo: anioProperties[0],
        descripcion: anioProperties[1],
      },
    });
  };

  handleStartDate = (date) => {
    this.clearFeedback();
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.clearFeedback();
    this.setState({ endDate: date });
  };

  handleStartInscriptionDate = (date) => {
    this.clearFeedback();
    this.setState({ startInscriptionDate: date });
  };

  handleEndInscripcionDate = (date) => {
    this.clearFeedback();
    this.setState({ endInscriptionDate: date });
  };

  isOkToSave() {
    return (
      this.state.periodo.length > 0
      && this.state.anio.descripcion.length > 1
      && this.state.startDate != null
      && this.state.endDate != null
      && this.state.endInscriptionDate != null
      && this.state.startInscriptionDate != null
    );
  }

  areDatesOk() {
    const startDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);
    return endDate > startDate;
  }

  areInscriptionDateOk() {
    const startInscripcionDate = new Date(this.state.startInscriptionDate);
    const endInscriptionDate = new Date(this.state.endInscriptionDate);
    return endInscriptionDate > startInscripcionDate;
  }

  areInscriptionDateInsidePeriodoDates() {
    const startDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);
    const startInscripcionDate = new Date(this.state.startInscriptionDate);
    const endInscriptionDate = new Date(this.state.endInscriptionDate);
    return (
      endDate >= startInscripcionDate
      && startInscripcionDate >= startDate
      && endDate >= endInscriptionDate
      && endInscriptionDate >= startDate
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    let errorMessage = '';
    const datesOk = this.areDatesOk();
    const inscriptionDatesOk = this.areInscriptionDateOk();
    const isOkToSave = this.isOkToSave();
    const inscriptionDateInsidePeriodoDates = this.areInscriptionDateInsidePeriodoDates();

    if (!isOkToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    }

    if (!datesOk) {
      if (errorMessage.length > 0) {
        errorMessage = errorMessage + ', la fecha de inicio no puede ser posterior a la fecha de fin';
      } else {
        errorMessage = 'La fecha de inicio no puede ser posterior a la fecha de fin';
      }
    }

    if (!inscriptionDatesOk) {
      if (errorMessage.length > 0) {
        errorMessage = errorMessage + ', la fecha de inicio de inscripción no puede ser posterior a la fecha de fin';
      } else {
        errorMessage = 'La fecha de inicio de inscripción no puede ser posterior a la fecha de fin';
      }
    }

    if (!inscriptionDateInsidePeriodoDates) {
      if (errorMessage.length > 0) {
        errorMessage = errorMessage + ', las fechas de inscripción deben estar dentro del rango de fechas ingresado para el período de cursada';
      } else {
        errorMessage = 'Las fechas de inscripción deben estar dentro del rango de fechas ingresado para el período de cursada';
      }
    }

    if (isOkToSave && datesOk && inscriptionDatesOk && inscriptionDateInsidePeriodoDates) {
      this.saveStudent();
    } else {
      this.setState({ errorMessage });
    }
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/pcr', {
      method: 'POST',
      body: JSON.stringify({
        PeriodoCursadaFechaInicio: constantClass.serializeDateForApi(this.state.startDate),
        PeriodoCursadaDescripcion: this.state.periodo,
        PeriodoCursadaFechaFin: constantClass.serializeDateForApi(this.state.endDate),
        PeriodoCursadaInicioInscripcio: constantClass.serializeDateForApi(this.state.startInscriptionDate),
        PeriodoCursadaFinInscripcion: constantClass.serializeDateForApi(this.state.endInscriptionDate),
        AnioAcademicoCod: this.state.anio.codigo,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el período de cursada. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-pcr" />;
    }

    const {
      loading,
      errorMessage,
      periodo,
      anio,
      startDate,
      endDate,
      startInscriptionDate,
      endInscriptionDate,
      showLookupAnios,
    } = this.state;
    const isBusy = loading;
    const selectedPeriodo = PERIODO_OPTIONS.find((o) => o.value === periodo) || PERIODO_OPTIONS[0];

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-pcr">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nuevo Período de Cursada</h1>
        <p className="md-form-page__subtitle">
          Complete el período, el año académico, las fechas de cursada y el rango de inscripción.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando período de cursada, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Período de Cursada</span>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="pcr-periodo"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  value={selectedPeriodo}
                  options={PERIODO_OPTIONS}
                  onChange={this.handlePeriodoChange}
                  isDisabled={isBusy}
                />
              </div>
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Año Académico</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowAniosLookup}
                disabled={isBusy}
              >
                Seleccione el Año Académico
              </button>
              {showLookupAnios ? (
                <LookupAnioAcademicos
                  selectItem={this.handleSelectAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={anio.descripcion}
                placeholder="Año académico seleccionado"
                readOnly
                disabled
                aria-label="Año académico"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pcr-fecha-inicio">
                Fecha de Inicio
              </label>
              <DatePicker
                id="pcr-fecha-inicio"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startDate}
                onChange={this.handleStartDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pcr-fecha-fin">
                Fecha de Fin
              </label>
              <DatePicker
                id="pcr-fecha-fin"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endDate}
                onChange={this.handleEndDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pcr-inscripcion-inicio">
                Fecha de Inicio de Inscripción
              </label>
              <DatePicker
                id="pcr-inscripcion-inicio"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startInscriptionDate}
                onChange={this.handleStartInscriptionDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pcr-inscripcion-fin">
                Fecha de Fin de Inscripción
              </label>
              <DatePicker
                id="pcr-inscripcion-fin"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endInscriptionDate}
                onChange={this.handleEndInscripcionDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
